import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import SubHeader from 'components/subHeader/SubHeader';
import SubVendorVechileTab from './SubVendorVechileTab';
import { getMatrixVehicle, getMoreVehicle, getVehicle, patchUpdateVehicle } from 'redux/actions/UserVehicle';
import { vehicleInfo as generateVehicleInfo } from 'pages/vendor/driverVendor/ViewDriverVendorData';
import { amenitiesVehicle as aminitiesVehicleInfo } from 'pages/vendor/driverVendor/ViewDriverVendorData';
import { editSubVehicleDialogData } from './SubVendorVechileData';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { handlePermissions } from 'utils/utils';

function VechileSubVendorView() {
  const dispatch = useDispatch();
  const role = localStorage.getItem('role')
  const {state} = useLocation();
  const id = state?.vehicleId;
  const name = state?.name;
  const [value, setValue] = useState('1');
  const vehicleData = useSelector((state) => state?.userVehicle?.userVehicle?.data);
  const vehicleMoreData = useSelector((state) => state?.userMoreVehicle?.userMoreVehicle?.data);
  const vehicleMatrixData = useSelector((state) => state?.userMatrixVehicle?.userMatrixVehicle?.data);
  const dialogData = editSubVehicleDialogData;
  const loadervehicle = useSelector((state) => state?.userVehicle?.loading);
  const filterData =  {
    vehicleId: id,
    status:"",
    page:"",
    pageSize:"",
    date:"",
    duration:""
  }

  const vehicleComplianceData = {
    submitterId: id,
    submitterType:"vehicle"
  }

  const vehicleMatrix = {
    vehicleId:id,
  }

  const urlSubVendor = window.location.pathname.includes('subvendor')
  const subVendorBreadcrumbPaths = [
    { name: 'City Manager', className:'colorGrey' ,},
    { name: 'Sub-Vendor', className:'colorGrey' ,},
    {name:'Vehicle',className:'colorGrey'},
    {name:name, url: '',className:'colorBlue'},
  ];
  const vehicleBreadcrumb = [
    {name:'Vehicle', url: '/Vehicle',className:'colorGrey'},
    {name:name, url: '',className:'colorBlue'},
  ];

  const subVendorVehicleBread = [
  { name: 'Sub-Vendor', className:'colorGrey' ,},
  {name:'Vehicle',className:'colorGrey'},
  {name:name, url: '',className:'colorBlue'},]

  const breadcrumbPaths =role === 'adminCompany' ?  urlSubVendor ? subVendorBreadcrumbPaths : [
    { name: 'City Manager', url: '/citymanager', className:'colorGrey' ,},
    {name:'Vehicle',className:'colorGrey'},
    {name:name, url: '',className:'colorBlue'},
  ] :urlSubVendor? subVendorVehicleBread: vehicleBreadcrumb ;

  useEffect(() => {
    dispatch(getVehicle(filterData));
      dispatch(getMatrixVehicle(vehicleMatrix));
  }, []);

  const vehicleInfotable = generateVehicleInfo(vehicleData); 
  const vehicleInfoaminities = aminitiesVehicleInfo(vehicleData);

  const onEditProfile = (data, code) => {
    const profileData = {
      vehicleId:id,
      data
    }
    dispatch(patchUpdateVehicle(profileData));
  }

  const handleTabChange = (newValue) => {
    setValue(newValue);
    if (newValue === '1'){
      dispatch(getMatrixVehicle(vehicleMatrix));
    } else if( newValue ==='2'){
      dispatch(getMoreVehicle(vehicleComplianceData));
    } else if (newValue === '3'){
      dispatch(getVehicle(filterData));
      dispatch(getMoreVehicle(vehicleComplianceData));
    }
  }

  //roles and permissions 
  const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
  const subVendorRoleEnum = roleAndPermissionEnum.subvendor
  const cityManagerRoleEnum = roleAndPermissionEnum.citymanager
  const driverRoleEnum = roleAndPermissionEnum.driver
  const vehicleRoleEnum = roleAndPermissionEnum.vehicle

  const accessCityManagerForAdd = handlePermissions(roleAndPermissions, cityManagerRoleEnum.moduleKey, {defaultAllAccess: cityManagerRoleEnum.all, customAccess: cityManagerRoleEnum.add});

  const accessForAdd = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {defaultAllAccess: subVendorRoleEnum.all, customAccess: subVendorRoleEnum.add});

  const accessForDriverAll = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {defaultAllAccess: driverRoleEnum.all, customAccess: driverRoleEnum.add});

  const editDriverAccess = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.edit});

  const editVehicleAccess = handlePermissions(roleAndPermissions, vehicleRoleEnum.moduleKey, {customAccess: vehicleRoleEnum.edit});

  const editButton = (accessCityManagerForAdd ||accessForAdd || accessForDriverAll|| editDriverAccess || editVehicleAccess)
  
  return (
    <div>
    <CommonBreadCrumb paths={breadcrumbPaths}/>
    <div className='profileVendorMain'>
    <SubHeader onSubmittBtn={onEditProfile} details={vehicleData} type={'Vehicle'} editData={dialogData(vehicleData)} loader={loadervehicle}/>
    </div>
    <SubVendorVechileTab
    onTabChange={handleTabChange}
    value={value}
    vehicleImage={vehicleMoreData} vehicleInfo={vehicleInfotable} 
      amenitiesVehicle={vehicleInfoaminities}
      vehicleMoreData={vehicleMoreData}
      vehicleMatrixData={vehicleMatrixData}
      editButton={editButton}/>
    </div>
  )
}

export default VechileSubVendorView;